module.exports = __webpack_public_path__ + "static/black_dragon-faec49937e4ab7ba2be2cdf178ed8968.jpg";